import { render, staticRenderFns } from "./monchartinfo.vue?vue&type=template&id=0ed97cbf&scoped=true&"
import script from "./monchartinfo.vue?vue&type=script&lang=js&"
export * from "./monchartinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed97cbf",
  null
  
)

export default component.exports